import React, { useEffect, useState } from "react";
import videoSrc1 from "../../../assets/video.mp4";
import videoSrc2 from "../../../assets/Truck-video.mp4";
import videoSrc3 from "../../../assets/Airways.mp4";
import "./Video.css";

const Video = () => {
  const [videoLoaded, setVideoLoaded] = useState(false);
  const [currentVideoIndex, setCurrentVideoIndex] = useState(0);
  const videoSources = [videoSrc1, videoSrc2, videoSrc3];

  useEffect(() => {
    const handleLoadedData = () => {
      setVideoLoaded(true);
    };

    const handleEnded = () => {
      setVideoLoaded(false);
      setCurrentVideoIndex(
        (prevIndex) => (prevIndex + 1) % videoSources.length
      );
    };

    const videoElement = document.getElementById("background-video");
    if (videoElement) {
      videoElement.addEventListener("loadeddata", handleLoadedData);
      videoElement.addEventListener("ended", handleEnded);
    }

    return () => {
      if (videoElement) {
        videoElement.removeEventListener("loadeddata", handleLoadedData);
        videoElement.removeEventListener("ended", handleEnded);
      }
    };
  }, [currentVideoIndex, videoSources.length]);

  return (
    <div className="video-container">
      <video
        id="background-video"
        className={`video-background ${videoLoaded ? "show" : "hide"}`}
        autoPlay
        muted
        src={videoSources[currentVideoIndex]}
      />
      <div className={`video-overlay ${videoLoaded ? "show" : "hide"}`}>
        <h1>Large Enough to Handle,</h1>
        <h1>Small Enough to Care</h1>
      </div>
    </div>
  );
};

export default Video;
